import { OnInit } from '@angular/core';
var RegistrationErrorComponent = /** @class */ (function () {
    function RegistrationErrorComponent() {
        this.eventName = '';
        this.formName = '';
        this.url = '';
        this.email = 'info@ez-events.com';
    }
    Object.defineProperty(RegistrationErrorComponent.prototype, "mailToLink", {
        get: function () {
            var subject = encodeURI("[Help] " + this.eventName + " - " + this.capitalize(this.formName) + " Registration");
            return "mailto:" + this.email + "?Subject=" + subject;
        },
        enumerable: true,
        configurable: true
    });
    RegistrationErrorComponent.prototype.ngOnInit = function () {
    };
    RegistrationErrorComponent.prototype.capitalize = function (value) {
        if (!value) {
            return '';
        }
        return value[0].toUpperCase() + value.slice(1);
    };
    return RegistrationErrorComponent;
}());
export { RegistrationErrorComponent };
